/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { TIMED_ENTRY_PREFIX } from '../constants';

export const FETCH_TOUR_IMAGES = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_IMAGES`;
export const FETCH_TOUR_IMAGES_SUCCESS = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_IMAGES_SUCCESS`;
export const FETCH_TOUR_IMAGES_ERROR = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_IMAGES_ERROR`;
export const SET_FETCH_TOUR_IMAGES_STATUS = `${TIMED_ENTRY_PREFIX}SET_FETCH_TOUR_IMAGES_STATUS`;

export function fetchTourImagesByFacilitySuccess(data) {
    return {
        type: FETCH_TOUR_IMAGES_SUCCESS,
        payload: data,
    };
}

export function fetchTourImagesByFacilityError(error) {
    return {
        type: FETCH_TOUR_IMAGES_ERROR,
        payload: error,
    };
}

export function setFetchTourImagesByFacilityStatus(status) {
    return {
        type: SET_FETCH_TOUR_IMAGES_STATUS,
        payload: status,
    };
}

export function fetchTourImagesByFacility({ facilityId, tourIds }) {
    return {
        type: FETCH_TOUR_IMAGES,
        payload: { facilityId, tourIds },
    };
}
